// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"styles_breadcrumb__vhhly"};